<template>
  <div class="api-info x-margin">
    <div class="x-border-50 x-margin-b">
      <my-head-title
        :title="$t('HT.apiInfo.title')"
        :showEdit="$hasModule(12)"
        @edit="edit"
      ></my-head-title>
      <div class="ul-item x-padding-info">
        <my-info-item :title="$t('HT.apiStepOne.name')" :info="formData.name"></my-info-item>
        <my-info-item
          :title="$t('HT.apiStepOne.groupId')"
          :info="formData.group_name"
        ></my-info-item>
        <my-info-item
          class="describe"
          :title="$t('HT.apiStepOne.remark')"
          start
          :info="formData.remark"
        ></my-info-item>
      </div>
    </div>
    <div class="x-border-50 x-margin-b">
      <my-head-title :title="$t('HT.apiStepTwo.title')"></my-head-title>
      <div class="ul-item x-padding-info" v-if="formData.request">
        <my-info-item :title="$t('HT.apiInfo.protocol')" :info="formData.protocol"></my-info-item>
        <my-info-item
          :title="$t('HT.apiStepThree.path')"
          :info="formData.request.uri"
        ></my-info-item>
        <my-info-item
          :title="$t('HT.apiStepThree.method')"
          :info="formData.request.method"
        ></my-info-item>
        <my-info-item :title="$t('HT.apiStepTwo.transferType')" :optionText="false">
          <span>{{ $opt.switchStr(formData.request.transfer_type, $opt.accessMode) }}</span>
        </my-info-item>
      </div>
    </div>
    <div
      class="x-border-50 x-margin-b"
      v-if="this.formData.request && this.formData.request.transfer_type !== 'PASS_THROUGH'"
    >
      <my-head-title :title="$t('HT.apiInfo.title2')"></my-head-title>
      <div class="x-padding" v-if="formData.request">
        <my-table
          ref="table"
          xborder
          :showPage="false"
          :tableData="formData.request.parameters || []"
          :columns="columns1"
        ></my-table>
      </div>
    </div>
    <div class="x-border-50 x-margin-b">
      <my-head-title :title="$t('HT.apiInfo.title3')"></my-head-title>
      <div class="ul-item x-padding-info" v-if="formData.service">
        <template v-if="formData.service.type === 'HTTP'">
          <my-info-item
            :title="$t('HT.apiStepThree.url')"
            :info="formData.service.url + formData.service.path"
          ></my-info-item>
          <my-info-item
            :title="$t('HT.apiStepThree.type')"
            :info="formData.service.type"
          ></my-info-item>
          <my-info-item
            :title="$t('HT.apiStepThree.method')"
            :info="formData.service.method"
          ></my-info-item>
          <my-info-item
            :title="$t('HT.apiInfo.timeout')"
            :info="formData.service.timeout"
          ></my-info-item>
        </template>
        <template v-else>
          <my-info-item
            :title="$t('HT.apiStepThree.type')"
            :info="formData.service.type"
          ></my-info-item>
          <my-info-item
            :title="$t('HT.apiStepThree.http')"
            :optionText="false"
            :info="formData.service.mock_http_status"
          ></my-info-item>
          <my-info-item
            class="describe"
            :title="$t('HT.apiInfo.mock')"
            start
            :optionText="false"
            :info="formData.service.mock_result"
          ></my-info-item>
        </template>
      </div>
    </div>

    <div
      class="x-border-50 x-margin-b"
      v-if="this.formData.request && this.formData.request.transfer_type !== 'PASS_THROUGH'"
    >
      <my-head-title :title="$t('HT.apiInfo.title4')"></my-head-title>
      <div class="x-padding" v-if="formData.service">
        <my-table
          ref="table"
          xborder
          :showPage="false"
          :tableData="formData.service.service_parameters || []"
          :columns="columns2"
        ></my-table>
      </div>
    </div>

    <div class="x-border-50 x-margin-b">
      <my-head-title :title="$t('HT.apiInfo.title5')"></my-head-title>
      <div class="ul-item x-padding-info" v-if="formData.response">
        <my-info-item
          class="describe"
          :title="$t('HT.apiInfo.contentType')"
          :info="formData.response.content_type"
        ></my-info-item>
        <my-info-item
          class="describe"
          :title="$t('HT.success')"
          start
          :info="formData.response.succeeded"
        ></my-info-item>
        <my-info-item
          class="describe"
          :title="$t('HT.fail')"
          start
          :info="formData.response.failed"
        ></my-info-item>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      apiId: this.$route.params.id, // api id
      formData: {}, /// api详情
      columns1: [
        // 入参定义表
        {
          label: this.$t('HT.apiStepTwo.paramsName'),
          prop: 'name',
          tooltip: true
        },
        {
          label: this.$t('HT.apiStepThree.origin'),
          prop: 'position',
          tooltip: true
        },
        {
          label: this.$t('HT.upgrade.type'),
          prop: 'type',
          tooltip: true
        },
        {
          label: this.$t('HT.required'),
          prop: 'required',
          tooltip: true,
          formatter: (row, column, cellValue) => {
            return JSON.stringify(cellValue);
          }
        },
        {
          label: this.$t('HT.default'),
          prop: 'default_value',
          tooltip: true
        },
        {
          label: this.$t('HT.example'),
          prop: 'example',
          tooltip: true
        },
        {
          label: this.$t('HT.apiStepOne.remark'),
          prop: 'remark',
          tooltip: true
        }
      ],
      columns2: [
        {
          label: this.$t('HT.apiStepThree.lowPressure'),
          prop: 'mapping_name',
          tooltip: true
        },
        {
          label: this.$t('HT.apiStepThree.hightPressure'),
          prop: 'mapping_position',
          tooltip: true
        },
        {
          label: this.$t('HT.apiStepThree.origin1'),
          prop: 'name',
          tooltip: true
        },
        {
          label: this.$t('HT.apiStepThree.origin2'),
          prop: 'position',
          tooltip: true
        },
        {
          label: this.$t('HT.apiStepThree.origin3'),
          prop: 'type',
          tooltip: true
        }
      ]
    };
  },
  created() {
    this.getInfo(this.apiId);
  },

  methods: {
    /**
     * 获取信息
     * @param {String} id 唯一标识
     */
    getInfo(id) {
      this.$uxLoading.show();
      this.$api.api.getInfo(id).then((res) => {
        if (res.code == 10000) {
          this.formData = res.data;
        }
      });
    },

    edit() {
      this.$router.push({ name: 'addApi', query: { id: this.apiId } });
    }
  }
};
</script>

<style lang="scss">
.api-info {
  .ul-item {
    display: flex;
    flex-wrap: wrap;

    .info-item {
      display: flex;
      width: 50%;
    }

    .describe {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      .x-flex-one {
        white-space: pre-wrap;
        word-wrap: break-word;
      }
    }
  }
}
</style>
